import { config } from '@psl/functions/config';
import AsyncStorage from '@psl/utils/asyncStorage';
import { Configuration } from '../../generated/api';
import { safeMarkDevFlag } from '../../utils/safeMarkDevFlag';
import BearerAuthMiddleware from './middlewares/BearerAuthMiddleware';
import DeviceInfoMiddleware from './middlewares/DeviceInfoMiddleware';
import ErrorWrappingMiddleware from './middlewares/ErrorWrappingMiddleware';
import FirestoreTimestampMiddleware from './middlewares/FirestoreTimestampMiddleware';
import LoggingMiddleware from './middlewares/LoggingMiddleware';

const kEnableRequestLogging = safeMarkDevFlag(false);
const kEnableResponseLogging = safeMarkDevFlag(false);
const kLogErrorResponseOnly = safeMarkDevFlag(true);

export const apiEndpoint$ = AsyncStorage.behaviorSubject$<string>(
  'services.api_endpoint',
);

class ConfigurationEx extends Configuration {
  get basePath(): string {
    if (config.isProd) {
      return super.basePath;
    }
    if (apiEndpoint$.value != null) {
      return apiEndpoint$.value;
    }
    return super.basePath;
  }
}

export default new ConfigurationEx({
  basePath: config.apiEndpoint,
  middleware: [
    new DeviceInfoMiddleware(),
    new BearerAuthMiddleware(),
    new LoggingMiddleware({
      requestLoggingEnabled: kEnableRequestLogging,
      responseLoggingEnabled: kEnableResponseLogging,
      logErrorResponseOnly: kLogErrorResponseOnly,
    }),
    new ErrorWrappingMiddleware(),
    new FirestoreTimestampMiddleware(),
  ],
});
